import React from 'react';
import { Box, Paper, UnstyledButton } from '@good/ui/core';
import { rosterConfig } from '../roster-config';
import { ROSTER_TAB } from '../components/roster-common-enums';
import { useCardPosition } from './use-card-position';

const { TIMELINE_CARD_HEIGHT } = rosterConfig;

interface RosterCardProps extends React.PropsWithChildren {
  bg?: string;
  borderColor?: string;
  className?: string;
  endDateTime: Date;
  onSelect: () => void;
  rowIndex?: number;
  selected: boolean;
  startDateTime: Date;
  tab: ROSTER_TAB;
  topSection?: React.ReactNode;
}

export const RosterCard = ({
  selected,
  onSelect,
  startDateTime,
  endDateTime,
  tab,
  rowIndex,
  children,
  bg,
  className,
  borderColor,
  topSection,
}: RosterCardProps) => {
  const { width, height, top, left } = useCardPosition(tab, startDateTime, endDateTime, rowIndex);

  return (
    <>
      <UnstyledButton
        onClick={onSelect}
        display='flex'
        w={width}
        h={height}
        top={top}
        left={left}
        pos={tab === ROSTER_TAB.DAILY ? 'absolute' : 'relative'}
        style={{
          zIndex: tab === ROSTER_TAB.DAILY ? 10 : 'auto',
          boxShadow: selected ? '0 0 0 2px var(--mantine-shadow-md)' : '',
          borderRadius: 'calc(var(--mantine-radius-md) - 2px)',
        }}
      >
        <Paper
          withBorder
          py={6}
          px={6}
          radius='md'
          w='100%'
          mih={TIMELINE_CARD_HEIGHT}
          shadow={selected ? 'xl' : 'xs'}
          bg={bg}
          style={{
            overflow: 'hidden',
            borderColor,
            outline: selected ? '2px solid var(--mantine-color-ocean-6)' : 'none',
          }}
          className={`anim-fade-in ${className}`}
        >
          {topSection && <Box pb={6}>{topSection}</Box>}
          {children}
        </Paper>
      </UnstyledButton>
    </>
  );
};
